/** @format */

export interface SEOTabContent {
  header: string;
  content: string;
}
